import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
import getMeasureTitle from "../../utils/Measure";
import "../../css/form/DropdownMeasure.css";

export default class Dropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = { id: 1, title: 'Total Body Water' };
    }

    componentWillMount () {
        var id    = parseInt(this.props.id);
        this.changeDDIdAndTitle(id)
    }

    componentDidUpdate(previousProps, previousState) {
        var new_id = this.props.id;

        if(previousProps.id !== this.props.id) {

            var id = parseInt(new_id);
            this.changeDDIdAndTitle(id)
        }
    }

    changeDDIdAndTitle(item_id) {
        var title;

        if(item_id == 1) {
            title = "Total Body Water"
        } else if(item_id == 2) {
            title = "Dry Lean Mass";
        } else if(item_id === 3) {
            title = "Body Fat Mass";
        } else if(item_id === 4) {
            title = "PBF";
        } else if(item_id === 5) {
            title = "SMM";
        } else if(item_id === 6) {
            title = "BMI";
        } else if(item_id === 7) {
            title = "Weight";
        } else if(item_id === 8) {
            title = "Right Arm";
        } else if(item_id === 9) {
            title = "Left Arm";
        } else if(item_id === 10) {
            title = "Trunk";
        } else if(item_id === 11) {
            title = "Right Leg";
        } else if(item_id === 12) {
            title = "Left Leg";
        } else
            title = "Total Body Water"

        this.setState({
            id:    item_id,
            title: title,
        });
    }

    onSelect(event) {
        var id    = event[0];
        var title = event[1]

        this.setState({
            id:    id,
            title: title
        });

        this.props.dropdownSelect(id); // update id in parent
    }

    render() {
        var show_none = this.props.showNoneOption;
        //var none = <MenuItem eventKey={["100", "None"]} >None</MenuItem>

        return (
            <DropdownButton id        = "DropdownMeasure"
                            onSelect  = {(event) => this.onSelect(event)}
                            title     = {this.state.title}
                            className = "dropdownMeasureCaret">

                        <MenuItem eventKey={["1", "Total Body Water"]} name="">Total Body Water</MenuItem>
                        <MenuItem eventKey={["2", "Dry Lean Mass"]} >Dry Lean Mass</MenuItem>
                        <MenuItem eventKey={["3", "Body Fat Mass"]} >Body Fat Mass</MenuItem>
                        <MenuItem eventKey={["4", "PBF"]} >PBF </MenuItem>
                        <MenuItem eventKey={["5", "SMM"]} >SMM</MenuItem>
                        <MenuItem eventKey={["6", "BMI"]} >BMI</MenuItem>
                        <MenuItem eventKey={["7", "Weight"]} >Weight</MenuItem>
                        <MenuItem eventKey={["8", "Right Arm"]} >Right Arm</MenuItem>
                        <MenuItem eventKey={["9", "Left Arm"]} >Left Arm</MenuItem>
                        <MenuItem eventKey={["10", "Trunk"]} >Trunk</MenuItem>
                        <MenuItem eventKey={["11", "Right Leg"]} >Right Leg</MenuItem>
                        <MenuItem eventKey={["12", "Left Leg"]} >Left Leg</MenuItem>
             </DropdownButton>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/assessment/DropdownInBody.js